import { isNil, size } from 'lodash';

import { formatNumber, isDebug } from 'utils/tools';

import { showIf } from './index.js';

let i = 0;

const debugLog = (...args) => isDebug && console.debug('(VEICULO-DIVULGACAO-DOC-VALIDACAO)', ++i, ...args);

export function Validacao({ metadata, data, documentos, enquadramento, obterPdfInfos = false }) {
	debugLog('metadata, dados: ', metadata, data, documentos);
	data = data || {};
	const SIM_NAO = { sim: 'Sim', nao: 'Não' };
	const optionToLabel = val => (/sim|nao/i.test(val) ? SIM_NAO[val] : val || null);

	const errors = {};
	const pdfInfos = [];

	metadata.vdDimensoes.forEach(dimensao => {
		dimensao.questoes.forEach(questao => {
			// valida perguntas da questão
			let mostrarQuestao =
				!questao.showIf || (questao.showIf && showIf(data, enquadramento, questao.showIf, `questao ${questao.id}`));
			if (questao.perguntas && mostrarQuestao) {
				let campos = [];
				questao.perguntas.forEach(pergunta => {
					let mostrarPergunta =
						!pergunta.showIf ||
						(pergunta.showIf && showIf(data, enquadramento, pergunta.showIf, `pergunta ${pergunta.id}`));
					if (mostrarPergunta) {
						const { id, placeholder, label, obrigatorio, required, type, options } = pergunta;

						// valida inputs obrigatórios
						if (size(pergunta.inputs) > 0) {
							pergunta.inputs.forEach(input => {
								let valor = data?.[input.id];
								valor = isNil(valor?.value) ? valor : valor?.value;
								if (input.obrigatorio && (size(valor) === 0 || parseFloat(valor) === 0)) {
									errors[input.id] = [`${input.label} é obrigatório`];
								}
								if (valor && ['number', 'area', 'multiplicador', 'api', 'multiplicacao'].includes(input.type)) {
									valor = formatNumber(valor, input.type === 'area' ? 2 : 0);
								} else if (input.type === 'radio') {
									valor = optionToLabel(valor);
								}
								campos.push({ label: input.label, valor, id: input.id });
							});
						}
						// valida documentos obrigatórios
						const docProperty = 'documentos';
						(pergunta[docProperty] || []).forEach(doc => {
							let mostrarDoc =
								!doc.showIf || (doc.showIf && showIf(data, enquadramento, doc.showIf, `documento ${doc.id}`));
							if (mostrarDoc) {
								const dAux = ultimoDocumento(documentos, doc.idDocumento);
								if (!dAux?.filename && doc.obrigatorio) {
									errors[doc.idDocumento] = [
										`Você precisa fornecer o documento ${doc.tituloDocumento} para a pergunta ${
											pergunta.numero || 'acima'
										}`
									];
								}
								campos.push({
									label: doc.tituloDocumento,
									valor:
										dAux && dAux.originalName ? `Documento anexado: ${dAux.originalName}` : 'Documento NÃO anexado',
									id: doc.idDocumento
								});
							}
						});
						// valida pergunta obrigatória
						if (
							((type === 'checkbox' && !data[id]) || (type !== 'checkbox' && size(data[id]) === 0)) &&
							(obrigatorio || required)
						) {
							errors[id] = [`Você precisa preencher o campo "${placeholder || label}"!`];
						} else if (size(label) > 0) {
							let valorAux = data[id];
							let isLista = false;
							// obtem campo personalizado
							if (type === 'checkbox') {
								valorAux = options
									.map(o => {
										if (Array.isArray(data[id]) && data[id].includes(o.codigo)) {
											return o.descricao;
										} else {
											return null;
										}
									})
									.filter(n => n);
								isLista = true;
							} else if (type === 'radio' && /sim|nao/i.test(data[id])) {
								valorAux = optionToLabel(data[id]);
							} else if (type === 'radio' && size(options) > 0) {
								valorAux = options.find(o => o.codigo === data[id])?.descricao;
							}
							campos.push({ label, valor: size(valorAux) > 0 ? valorAux : 'Sem resposta', id: pergunta.id, isLista });
						}
					}
				});
				if (size(campos) > 0) {
					pdfInfos.push({
						titulo: questao.subtitle,
						campos
					});
				}
			}
		});
	});

	return obterPdfInfos ? pdfInfos : errors;
}

function ultimoDocumento(documentos, tipoDocumento) {
	const doc = (documentos || [])
		.filter(d => d.idDocumento === tipoDocumento)
		.reduce((acc, d) => ((acc || {}).versao > d.versao ? acc : d), null);
	return doc;
}
